<div
  style="
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    background: #000000;
  "
>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: var(--iframe-gap);
      align-items: center;
      background: var(--iframe-modal-bg);
      border-radius: 20px;
      padding: 20px;
      max-width: 320px;
      width: calc(100% - 40px);
      max-height: 90vh;
      overflow-y: auto;
    "
  >
    <!-- Header -->
    <div style="display: flex; align-items: center; gap: var(--iframe-gap); justify-content: center">
      {{#if metadataLogo}}
      <img
        src="{{metadataLogo}}"
        alt="{{metadataName}}"
        style="width: 48px; height: 48px; border-radius: 24px; object-fit: cover"
      />
      {{else}}
      <span
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 24px;
          background-color: var(--iframe-button-bg);
          color: var(--iframe-button-text);
          font-size: 14px;
          font-weight: 600;
        "
        >🔐</span
      >
      {{/if}}

      <!-- ------------------------------------------------------------ -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--iframe-text-secondary)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
      </svg>
      <!-- ------------------------------------------------------------ -->

      {{#if userAvatar}}
      <img
        src="{{userAvatar}}"
        alt="{{userName}}"
        style="width: 48px; height: 48px; border-radius: 24px; object-fit: cover"
      />
      {{else}}
      <span
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 24px;
          background-color: var(--iframe-button-bg);
          color: var(--iframe-button-text);
          font-size: 14px;
          font-weight: 600;
        "
        >U</span
      >
      {{/if}}
    </div>

    <div style="display: flex; align-items: center; gap: var(--iframe-gap); justify-content: center">
      <span
        style="
          width: fit-content;
          font-size: var(--iframe-h2-fz);
          font-weight: var(--iframe-heading-fw);
          line-height: 150%;
          text-align: center;
        "
        >Signature Request</span
      >
    </div>

    <div class="domain-info verified">
      <span style="display: block; width: 100%; font-size: 12px; text-align: center; font-family: monospace">
        {{#if isVerifiedOrigin}}
        <span>✓</span>
        {{/if}} {{origin}}</span
      >
    </div>

    <!-- EIP712 Message Content -->
    <div class="eip712-content">
      <details class="eip712-details">
        <summary>Advanced details</summary>

        <div class="section-title">📝 Message</div>
        <div class="eip712-section">
          <div class="section-subtitle">{{primaryType}}</div>
          {{messageFields}}
        </div>

        <div class="section-title" style="margin-top: 16px">🔍 Domain</div>
        <div class="eip712-section">{{domainFields}}</div>

        <div class="section-title" style="margin-top: 16px">📋 Full Message</div>
        <pre class="eip712-raw"><code>{{fullMessageJson}}</code></pre>
      </details>
    </div>

    <!-- Trust App Option -->
    <div class="trust-app-section">
      <label class="trust-app-label">
        <input type="checkbox" class="trust-app-checkbox" />
        <span>Trust this application and skip confirmation for future signatures</span>
      </label>
    </div>

    <!-- Action Buttons -->
    <div class="actions">
      <button class="cancel-btn">Reject</button>
      <button class="confirm-btn">Sign</button>
    </div>

    <!-- Footer Notice -->
    <div class="footer-notice">
      <p class="footer-note">Only sign messages from applications you trust.</p>
    </div>
  </div>
</div>
